//import { useState } from 'react';
import { Route, useRouteMatch, useHistory } from "react-router-dom";
import { imgUrl } from "./modules/Arrays";
import Album from "./Album";
import Track from "./Track";

function Albums({ albums }) {
    const { url, path } = useRouteMatch();
    const history = useHistory();
    const albumss = albums.map(album => (
        <Track song={album} key={album.id} link={`${url}${album.url}`} img={imgUrl+"next.png"} alt={`Go to ${ album.title }`} />
    ));
    
  return (
    <div className="musicals">

        <Route exact path={path}>
            <button onClick={history.goBack}>Back</button>
            {
                albums.length === 0 ? 
               
                <h3>No Albums yet </h3>
                 :
                <>
                <h4>All Albums</h4>
                <div className="grid-4">
                    {albumss}
                </div>
                </>
            }
            
        </Route>
        <Route path={path+"/:alb"}>
            <Album />
        </Route>

    </div>

  );

}

export default Albums;